module.exports = __webpack_public_path__ + "img/status-arrived.2c43c77a.svg";